import * as React from 'react'
import { SVGProps } from 'react'
const SvgFormats = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#formats_svg__a)" fill="currentColor">
      <path d="M35.476 0H18.292l-.873.873L5.345 12.947l-.873.873v26.127c0 4.44 3.612 8.053 8.053 8.053h22.95c4.44 0 8.053-3.613 8.053-8.053V8.053C43.528 3.612 39.916 0 35.476 0Zm5.07 39.947a5.07 5.07 0 0 1-5.07 5.071H12.525a5.07 5.07 0 0 1-5.071-5.07V15.054h7.848a4.226 4.226 0 0 0 4.226-4.225V2.982h15.948c2.8 0 5.07 2.27 5.07 5.07v31.895Z" />
      <path d="M19.179 23.868v7.202a3.883 3.883 0 0 0-2.068-.148c-1.778.343-3.003 1.746-2.736 3.134.268 1.388 1.926 2.236 3.705 1.893 1.578-.304 2.719-1.444 2.768-2.67h.01v-9.522l8.524-1.281v7.09a3.892 3.892 0 0 0-2.067-.146c-1.779.342-3.004 1.745-2.736 3.134.267 1.387 1.925 2.235 3.704 1.892 1.579-.304 2.72-1.444 2.767-2.668h.01V19.237L19.18 20.739v3.129Z" />
    </g>
    <defs>
      <clipPath id="formats_svg__a">
        <path fill="currentColor" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgFormats
